export default __webpack_public_path__ + "2ca13c9.png";